var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute, Router } from "@angular/router";
import * as qs from 'qs';
import { TranslateService } from "app/translate/translate.service";
import { FilterFormService } from "app/views/filter_form/filter_form.service";
import { HttpClient } from "@angular/common/http";
import { HelperService } from "app/lib/helper.service";
import { ChartParams } from "app/views/chart/chart.component";
import { ModalService } from "app/views/modal/base_modal.component";
import { BaseComponent } from "app/views/base.component";
import { EventsService } from "app/lib/EventsService";
import { AttachDomainDetailsComponent } from "./details/attach_domain_details/attach_domain_details.component";
import { SaveContactDetailsComponent } from "./details/save_contact_details/save_contact_details.component";
import { DetailsComponent } from "./details/details/details.component";
import dictionary from "dict/static.json";
import { DomainsService } from "../domains.service";
var DomainActionsComponent = /** @class */ (function (_super) {
    __extends(DomainActionsComponent, _super);
    function DomainActionsComponent(eventsService, activatedRoute, translate, router, filter, http, helper, modalService, domainsService) {
        var _this = _super.call(this, eventsService, domainsService, activatedRoute, filter, translate) || this;
        _this.eventsService = eventsService;
        _this.activatedRoute = activatedRoute;
        _this.translate = translate;
        _this.router = router;
        _this.filter = filter;
        _this.http = http;
        _this.helper = helper;
        _this.modalService = modalService;
        _this.domainsService = domainsService;
        _this.paginationLoader = false;
        _this.statsLoader = true;
        _this.chartData = new ChartParams();
        _this.dontLoad = {};
        _this.domainParamsMap = {
            'searchedCount': 'searchDomain',
            'searchedUniqCount': 'searchUniqDomain',
            'selectedCount': 'selectedDomain',
            'paidCount': 'paidDomain',
            'saveContactCount': 'saveContactDomain',
            'attachCount': 'attachDomain'
        };
        _this.addFilterParams = {
            userType: 'user',
            isDomainBilling: true,
            dateFilters: ['dateCreated', 'dateDomainAction', 'dateSiteCreated'],
            dateType: 'datePaid'
        };
        _this.chartData.setOptions({
            names: {
                'searchedCount': _this.translate.__A('billing.domain_billing.searchedCount'),
                'searchedUniqCount': _this.translate.__A('billing.domain_billing.searchedUniqCount'),
                'selectedCount': _this.translate.__A('billing.domain_billing.selectedCount'),
                'saveContactCount': _this.translate.__A('billing.domain_billing.saveContactCount'),
                'attachCount': _this.translate.__A('billing.domain_billing.attachCount'),
                'paidCount': _this.translate.__A('billing.domain_billing.paidCount'),
                "prolongationCount": _this.translate.__A('billing.domain_billing.prolongationCount.title')
            }
        });
        return _this;
    }
    DomainActionsComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                _super.prototype.ngOnInit.call(this);
                this.currencyList = dictionary.currencyList;
                return [2 /*return*/];
            });
        });
    };
    DomainActionsComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getChart()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getStats()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // Получить данные для графика
    DomainActionsComponent.prototype.getChart = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var charts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.dontLoad.chart)
                            return [2 /*return*/, true];
                        this.chartData.showLoader();
                        return [4 /*yield*/, this.domainsService.actions.chart(this.filter.getCopyFilterParams(params)).toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        this.chartData.data = charts;
                        this.chartData.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    // Получить данные для пагинации
    DomainActionsComponent.prototype.getStats = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, pagination;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        me.statsLoader = true;
                        if (!me.dontLoad.pagination) return [3 /*break*/, 2];
                        return [4 /*yield*/, me.getTable()];
                    case 1:
                        _a.sent();
                        me.statsLoader = false;
                        return [2 /*return*/, true];
                    case 2:
                        if (!(me.filter.filterParams.period !== 'summary')) return [3 /*break*/, 4];
                        return [4 /*yield*/, me.domainsService.actions.pagination(this.filter.filterParams).toPromise()];
                    case 3:
                        pagination = _a.sent();
                        me.pagination.fill(pagination);
                        if (pagination) {
                            me.updateLinks(me.domainsService.actions.getRealFullRoute());
                        }
                        _a.label = 4;
                    case 4: return [4 /*yield*/, me.getTable()];
                    case 5:
                        _a.sent();
                        this.statsLoader = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    // Получить данные для stats
    DomainActionsComponent.prototype.getTable = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, stats, _i, _a, stat, dates;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        me = this;
                        return [4 /*yield*/, me.domainsService.actions.stats(me.filter.getCopyFilterParams({
                                paginationDate: me.pagination.getDate()
                            })).toPromise()];
                    case 1:
                        stats = (_b.sent()).stats;
                        me.stats = stats;
                        for (_i = 0, _a = this.stats; _i < _a.length; _i++) {
                            stat = _a[_i];
                            dates = me.helper.getTimeAsIntervals({
                                timestamp: stat.timestamp,
                                period: me.filter.filterParams.period
                            });
                            if (dates.length == 2) {
                                stat.currentPeriod = dates[0] + '-' + dates[1];
                            }
                            else {
                                stat.currentPeriod = dates[0];
                            }
                            stat.day = new Date(stat.timestamp).getDay();
                            if (stat.currentPeriod == '') {
                                stat.currentPeriod = 'summary';
                            }
                        }
                        me.dontLoad = {};
                        return [2 /*return*/];
                }
            });
        });
    };
    // Клик по пагинации
    DomainActionsComponent.prototype.onPageChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                this.filter.filterParams.page = this.pagination.page;
                this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);
                params = this.filter.getApplyFilters(this.filter.filterParams), url = this.router.url.split('?')[0];
                params = qs.stringify(params, { encode: false });
                this.router.navigateByUrl(url + "?" + params, { relativeTo: this.activatedRoute });
                this.dontLoad = {
                    chart: true,
                    pagination: true
                };
                return [2 /*return*/];
            });
        });
    };
    DomainActionsComponent.prototype.showDetails = function (key, stat) {
        return __awaiter(this, void 0, void 0, function () {
            var domainStatType, details, component, stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        domainStatType = {
                            'searchedCount': 'searchDomain',
                            'searchedUniqCount': 'searchUniqDomain',
                            'selectedCount': 'selectedDomain',
                            'saveContactCount': 'saveContactDomain'
                        }[key];
                        if (!(key === 'attachCount')) return [3 /*break*/, 1];
                        details = stat.attachList;
                        component = AttachDomainDetailsComponent;
                        return [3 /*break*/, 3];
                    case 1:
                        if (key === 'searchedCount' || key === 'searchedUniqCount' || key === 'selectedCount') {
                            component = DetailsComponent;
                        }
                        else if (key === 'saveContactCount') {
                            component = SaveContactDetailsComponent;
                        }
                        else {
                            throw new Error("Domain Action.showDetails: key \"" + key + "\" in unknown!");
                        }
                        return [4 /*yield*/, this.domainsService.actions.detail(this.filter.getCopyFilterParams({
                                groupDate: stat.groupDate,
                                domainStatType: domainStatType,
                            })).toPromise()];
                    case 2:
                        stats = (_a.sent()).stats;
                        details = stats;
                        _a.label = 3;
                    case 3:
                        this.modalService.open(component, {
                            title: this.translate.__A('billing.domain_billing.' + key + '.title') + ': ' + stat.currentPeriod,
                            details: details,
                        }, { size: 'hg' });
                        return [2 /*return*/];
                }
            });
        });
    };
    DomainActionsComponent.prototype.updateData = function (filter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getChart(filter)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return DomainActionsComponent;
}(BaseComponent));
export { DomainActionsComponent };
